<template>
  <div class="classify">
    <div class="top-box flex-center">
      <img src="../../assets/img/classify/bobo@2x.png" alt="" class="logo" />
      <div class="search-box flex-center" @click="$router.push('/search')">
        <img
          src="../../assets/img/classify/search@2x.png"
          alt=""
          class="icon"
        />
        <input
          type="search"
          placeholder="请输入搜索内容"
          v-model="searchVal"
          @keydown.enter="onSearch"
        />
      </div>
    </div>
    <div class="content">
      <div class="left-box">
        <div
          class="left-item-box"
          v-for="item in typeList"
          :key="item.id"
          :class="{ active: typeId == item.id }"
          @click="changeType(item)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="right-box">
        <div class="item-block">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item
              v-for="item in recommends"
              :key="item.id"
              class="base-swipe-item"
            >
              <img :src="item.thumb" alt="" />
            </van-swipe-item>
            <van-swipe-item class="holder" v-if="!recommends.length">
              <span>暂无图片</span>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="type-item-block" v-for="item in list" :key="item.id">
          <div class="title-row flex-between">
            <strong>{{ item.title }}</strong>
            <div
              to
              class="flex-center more-link"
              @click="item.show = false"
              v-if="item.show"
            >
              <span>收起</span>
              <img
                src="../../assets/img/classify/zhankai@2x.png"
                alt=""
                class="icon"
              />
            </div>
            <div
              to
              class="flex-center more-link"
              @click="openMore(item)"
              v-else
            >
              <span>查看更多</span>
              <img
                src="../../assets/img/classify/zhankai@2x.png"
                alt=""
                class="icon"
              />
            </div>
          </div>
          <van-grid class="list-block" :column-num="3" :border="false">
            <van-grid-item
              :class="{ 'hide-item': !item.show }"
              :icon="innerItem.thumb"
              :text="innerItem.title"
              v-for="innerItem in item.children"
              :key="innerItem.id"
              @click="
                $router.push(`/search?id=${innerItem.id}`)
              "
            />
          </van-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      searchVal: "",
      typeList: [],
      typeId: -1,
      list: [],
      recommends: [],
    };
  },
  pass: true,
  computed: {},
  methods: {
    getRecommends() {
      this.$post({
        url: "/portal/Shop",
        module: "GoodsCategory",
        interface: "1002",
        data: {},
      }).then((res) => {
        // console.log("推荐图", res);
        this.recommends = res.list;
      });
    },
    changeType(typeItem) {
      if (this.typeId == typeItem.id) {
        return;
      }
      this.typeId = typeItem.id;
      this.getList();
    },
    onSearch() {
      this.$toast(`搜索${this.searchVal}`);
    },
    getBase() {
      this.$post({
        url: "/portal/Shop",
        module: "GoodsCategory",
        interface: "1001",
        data: {},
      }).then((res) => {
        // console.log(res);
        this.typeList = res.list;
        if (res.list.length) {
          this.changeType(res.list[0]);
        }
      });
    },
    getList() {
      this.$post({
        url: "/portal/Shop",
        module: "GoodsCategory",
        interface: "1003",
        data: {
          parentId: this.typeId,
        },
      }).then((res) => {
        // console.log(res);
        this.list = res.list;
      });
    },
    openMore(item) {
      this.$set(item, "show", true);
    },
  },
  created() {
    this.getBase();
    this.getRecommends();
  },
};
</script>

<style lang='less' scoped>
.icon {
  width: 22px;
  height: 22px;
}

.classify {
  font-family: PingFangSC-Medium, PingFang SC;
  height: calc(100vh - 50px);
  background-color: #f0f2f5;

  .top-box {
    padding: 16px 16px 22px 9px;

    .logo {
      width: 84px;
      height: 26px;
    }

    .search-box {
      flex: 1;
      padding: 4px 7px;
      background: #fff2f4;
      border-radius: 15px;
      margin-left: 8px;

      input {
        font-size: 14px;
        color: #fd0212;
        padding: 0 3px;
      }
    }
  }

  .content {
    height: calc(100% - 68px);
    display: flex;

    .left-box {
      width: 120px;
      height: 100%;
      background: #f7f7f7;
      overflow: auto;

      .left-item-box {
        padding: 10px 15px;
        text-align: center;
        font-weight: 600;
        color: #414245;

        &.active {
          background: #ffffff;
          color: #fd0212;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            width: 5px;
            height: 18px;
            background: #fd0212;
            border-radius: 0px 4px 4px 0px;
            left: 0;
            top: calc(50% - 9px);
          }
        }
      }
    }

    .right-box {
      flex: 1;
      height: 100%;
      overflow: auto;

      .item-block {
        padding: 0 16px;

        .my-swipe {
          height: 92px;

          .base-swipe-item > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .van-swipe-item.holder {
            background-color: #f7f7f7;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
            color: #808080;
            font-size: 14px;
          }
        }
      }

      .type-item-block {
        margin-bottom: 20px;
        padding: 0 7px 0 16px;

        &:last-child {
          margin-bottom: 20px;
        }

        .title-row {
          font-size: 12px;
          margin-bottom: 7px;

          strong {
            color: #101010;
          }

          .more-link {
            color: #c0c4cc;
          }
        }

        .list-block {
          margin-right: 9px;
          box-shadow: 0px 6px 12px 0px rgba(16, 16, 16, 0.1);
          border-radius: 12px;
          overflow: hidden;
          text-align: center;

          .hide-item {
            &:nth-child(6n) ~ .hide-item {
              display: none;
            }
          }

          /deep/.van-icon__image {
            width: 44px;
            height: 44px;
          }
		  /* /deep/.van-grid-item{
			  border:1px solid #e0e0e1;
			  margin:5px;
		  } */
          /deep/.van-grid-item__content--center {
            justify-content: flex-start;
			/* .van-grid-item__text{
				border:1px solid #e0e0e1;
				padding:3px;
			} */
          }
        }
      }
    }
  }
}
</style>
